'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CheckboxComponent } from './component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports     : [
    BrowserModule,
    FormsModule
  ],
  declarations: [CheckboxComponent],
  exports     : [CheckboxComponent]
})
export class LKCheckbox {
}
